var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-stats"},_vm._l((_vm.children),function(child,index){return _c('div',{key:index,staticClass:"c-stats__item"},[_c('div',{staticClass:"c-stats__label"},[_vm._v(_vm._s(child.label))]),_c('div',{staticClass:"c-stats__value"},[_vm._v(_vm._s(child.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }